import React, { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import { useParams } from 'react-router'
import { LangContext } from '../../context/lang-context'
import useFetch from '../../hooks/fetchMSSQL-hook'
import moment from "moment";
import { NavigationContext } from '../../context/navigation-context'
import { Prompt } from 'react-router-dom/cjs/react-router-dom.min'
import link from '../../assets/images/back_to_list_icon.svg'

const FZ = () => {
  const { TRL_Pack } = useContext(LangContext)
  const { fetchMssqlApi } = useFetch()
  const { warehouseOperationId } = useParams()
  const { setHeaderData } = useContext(NavigationContext)
  const [avaiableToSave, setAvaiableToSave] = useState(false)
  const [closed, setClosed] = useState(false)
  const [products, setProducts] = useState([])
  const [warehouses, setWarehouses] = useState([])
  const [contractors, setContractors] = useState([])
  const [initialItems, setInitialItems] = useState([])
  const [items, setItems] = useState([])
  const [changed, setChanged] = useState(false)
  const [isSaved, setIsSaved] = useState(false)
  const [sortBy, setSortBy] = useState("none")
  const [initialFZ, setInitialFZ] = useState({      
    TotalNetto: parseFloat(0.0),
    TotalBrutto: parseFloat(0.0),
    TotalVAT: parseFloat(0.0),
    ContractorName: "",
    IssuedOn: moment().format("YYYY-MM-DD"),
    Created: "",
    PaymentDate: moment().format("YYYY-MM-DD"),
    ContractorId: 0,
    Comment: '',
    IsPaid: false,
    OriginalDocNumber: '',
    WarehouseFullName: '',
    FromWarehouseId: null
  })
  const isNew = warehouseOperationId === "0"
  const [FZ, setFz] = useState({})

  const sortDefaults = {
    Name: "ASC",
    Quantity: "DESC",
    Price: "DESC",
    PriceNetto: "DESC",
    VAT: "DESC",
    Value: "ASC",
    PriceBrutto: "DESC"
  }

  const getSortState = () => {
    const [field, dir] = String(sortBy || "").split("|")
    return { field, dir: (dir || "").toUpperCase() }
  }

  const sortState = getSortState()

  const arrow = (field) => {
    if (sortState.field !== field) return ""
    return sortState.dir === "ASC" ? " ▲" : " ▼"
  }

  const handleHeaderSort = (field) => {
    const [curField, curDirRaw] = String(sortBy || "").split("|")
    const curDir = (curDirRaw || "").toUpperCase()

    let nextDir
    if (curField === field) {
      nextDir = curDir === "ASC" ? "DESC" : "ASC"
    } else {
      nextDir = sortDefaults[field] || "ASC"
    }

    const nextSortBy = `${field}|${nextDir}`
    setSortBy(nextSortBy)
    getFZItems(nextSortBy)
  }

  const random = () => { 
  const set = new Set(items.map(item => +item.WarehouseOperationItemId))
  const a = Math.floor(Math.random()*10000)
  return set.has(a) ? random() : a}
  const newFZItem = {
    new: true,
    Price: 0,
    PriceBrutto: 0,
    PriceNetto: 0,
    ProductId: null,
    Quantity: 0,
    VAT: 0,
    VATId: null,
    Value: 0,
    WarehouseOperationItemId: String(random())
  }
  
  const getFZItems = (nextSortBy = sortBy) => {
    if (warehouseOperationId !== "0") {
      const query = nextSortBy && nextSortBy !== "none"
        ? `?sortBy=${encodeURIComponent(nextSortBy)}`
        : ""

      fetchMssqlApi(`fz/${warehouseOperationId}${query}`, { hideNotification: true }, fz => setInitialItems(fz))
    }
    else setInitialItems([])
  }

  const getDate = date => {
    if(!date ) return null
    if (date.includes(" ")) {
      date = date.split(" ")
      return date[0]
    } else if (date.includes("T")) {
      date = date.split("T")
      return date[0]
    }
    return null
  }
  const getFz = () => {
    if (warehouseOperationId !== "0") fetchMssqlApi(`fz`, {method: "POST", data: {warehouseOperationId}, hideNotification: true}, fz => 
    {
      setInitialFZ(() => ({...fz, IssuedOn: getDate(fz.IssuedOn), PaymentDate: getDate(fz.PaymentDate)}))
      fz.WarehouseInventoryId ? setClosed(true) : setClosed(false)
    })
    else setFz(initialFZ)
  }

  useEffect(() => {
    setHeaderData({
      text: TRL_Pack.fz.fz
    });
    getFz()
    getFZItems();
    getProducts();
    getWarehouses();
    getContractors();
    
  }, [])
  useEffect(() => {
    setFz(initialFZ)
  }, [initialFZ])
  useEffect(() => {
    setItems(initialItems)
  }, [initialItems])

  const getNetto = ({Price, Quantity}) =>  (Number(Quantity) * Number(Price)).toFixed(2) || 0
  const getVat = (netto, Value) => (Number(netto) * Number(Value) / 100).toFixed(2) || 0
  const getBrutto = (netto, vat) => (Number(netto) + Number(vat)).toFixed(2) || 0
  const totalBruttoSum = () => items && (items.map(item => !item.deleted && getBrutto(getNetto(item), getVat(getNetto(item), item.Value) ) )).reduce((a, b) => +a + +b, 0)
  const totalNettoSum = () => items && (items.map(item => !item.deleted && getNetto(item))).reduce((a, b) => +a + +b, 0)
  const totalVatSum = () => items && (items.map(item => !item.deleted && getVat(getNetto(item), item.Value) ).reduce((a, b) => +a + +b, 0))
  const deleteItem = (id) => {
    const item = items.find(item => item.WarehouseOperationItemId === id)
    item.new ? setItems(prev => prev.filter(item => item.WarehouseOperationItemId !== id)) 
    : setItems(prev => prev.map(a => a.WarehouseOperationItemId === id ? ({...a, deleted: true}) : (a)))
  }




  const handleChangeItem = (id, evt) => {
    const name = evt.target.value
    setChanged(true)
    const product = products.find(pr => pr.Name === name)
    product ? evt.target.className = "form-control form-control-sm mx-auto mx-lg-0" : evt.target.className += " invalid-input"
    product
    ? setItems(prev => prev.map(item => {
      if(item.WarehouseOperationItemId === id) {return {
        ...item,
        Name: product.Name,
        Price: item.Price,
        PriceBrutto: getBrutto(getNetto(item), getVat(getNetto(item), +product.VATValue)),
        PriceNetto: getNetto(item),
        ProductId: product.ProductId,
        Quantity: item.Quantity,
        VAT: getVat(getNetto(item), +product.VATValue),
        VATId: product.VATId,
        Value: product.VATValue,
      }} else return item
    }))
    : setItems(prev => prev.map(item => item.WarehouseOperationItemId === id ? ({...item, Name: name}) : (item)))
  }

  const handleChangeQuantity = (id, quantity) => {
    setChanged(true)
    setItems(prev => prev.map(item => item.WarehouseOperationItemId === id ? ({
      ...item,
      Quantity: quantity.replace(/[^0-9]/, ""),
    }) : item))
  }

  const handleChangePrice = (id, price) => {
    setChanged(true)
    setItems(prev => prev.map(item => item.WarehouseOperationItemId === id ? ({
      ...item,
      Price: price.replace("e", ""),
    }) : item))
  }

  const handleChangeContractor = (e) => {
    const evt = e.target
    setChanged(true)
    const contractor = contractors.find(data => data.Name === evt.value)
    if (!contractor) {
      evt.className += " invalid-input"
      setFz(prev => ({...prev, ContractorName: evt.value}))
    } else {
      evt.className = "mt-2 form-control form-control-sm"
      setFz(prev => ({...prev, ContractorName: evt.value, ContractorId: contractor.ContractorId}))
    }
  }

  const handleChangeWarehouse = (e) => {
    const evt = e.target
    setChanged(true)
    const warehouse = warehouses.find(data => data.Name === evt.value)
    if (!warehouse) {
      evt.className += " invalid-input"
      setFz(prev => ({...prev, WarehouseFullName: evt.value}))
    } else {
      evt.className = "mt-2 form-control form-control-sm"
      setFz(prev => ({...prev, WarehouseFullName: evt.value, FromWarehouseId: warehouse.WarehouseId}))
    }
  }
  useEffect(() => {
    setFz(prev => ({...prev, ContractorId: contractors && contractors.find(data => data.Name === prev.ContractorName)?.ContractorId || null }))
  }, [initialFZ, contractors])
  useEffect(() => {
    setFz(prev => ({...prev, FromWarehouseId: warehouses && warehouses.find(data => data.Name === prev.WarehouseFullName)?.WarehouseId || null}))
  }, [initialFZ,warehouses])
  useEffect(() => {
    ![...items].filter(item => !item.deleted).length ||
    items.some(item => !item.Quantity || !item.Price || !item.ProductId) ||
    !FZ.OriginalDocNumber ||
    !FZ.FromWarehouseId ||
    !FZ.ContractorId ||
    !FZ.IssuedOn ||
    !FZ.PaymentDate ? setAvaiableToSave(false) : setAvaiableToSave(true)
  }, [items, FZ])

  const getProducts = () => {
    fetchMssqlApi('products', { method: "POST", hideNotification: true, data: {}}, products => setProducts(products))
  }
  const getWarehouses = () => {
    fetchMssqlApi('warehouses-list', {}, warehouses => setWarehouses(warehouses))
  }

  const getContractors = () => {
    fetchMssqlApi('contractors-list', {}, contractors => setContractors(contractors))
  }
  const handleSubmit = () => {
    const {IssuedOn, 
      WarehouseOperationId, 
      WarehouseOperationFullName,
      OriginalDocNumber,
      ContractorId,
      FromWarehouseId,
      PaymentDate,
      ToWarehouseOperationId,
      IsPaid,
      RelatedDoc,
      Comment,
      Created} = FZ
    const FZpayload = {
      Comment,
      IssuedOn: moment(IssuedOn).format("YYYY-MM-DD 03:00:00") || moment.format("YYYY-MM-DD HH:MM:SS"),
      WarehouseOperationId, 
      WarehouseOperationFullName,
      OriginalDocNumber,
      ContractorId,
      FromWarehouseId,
      FromWarehouseId,
      PaymentDate: moment(PaymentDate).format("YYYY-MM-DDT03:00:00.000") || moment.format("YYYY-MM-DDT03:00:00.000"),
      ToWarehouseOperationId,
      IsPaid,
      RelatedDoc,
      Created
    }
    const FZitems = items
      .filter(item => !(item.deleted && item.new))
      .map(item => {
        const vatRate = Number(item.Value ?? item.VATRate ?? 0);
        const unitNet = Number(item.Price || 0);
        const unitBrutto = (unitNet * (1 + vatRate / 100)).toFixed(2);

        return warehouseOperationId === "0"
          ? {
              ProductId: item.ProductId,
              Price: unitNet,
              Quantity: item.Quantity,
              PriceBrutto: unitBrutto,
              VAT: vatRate,
              WarehouseOperationId: FZ.WarehouseOperationId
            }
          : {
              deleted: item.deleted ? 1 : 0,
              new: item.new ? 1 : 0,
              WarehouseOperationItemId: item.WarehouseOperationItemId,
              ProductId: item.ProductId,
              Price: unitNet,
              Quantity: item.Quantity,
              PriceBrutto: unitBrutto,
              VAT: vatRate,
              ToWarehouseOperationId: FZ.ToWarehouseOperationId
            };
      });
    const payload = {
      FZ: FZpayload,
      Items: FZitems
    }
    if (warehouseOperationId === "0") {
      fetchMssqlApi('fz/new', {method: "POST", data: payload}, () => {
        setIsSaved(true)
      })
    } else {
      fetchMssqlApi(`fz/${warehouseOperationId}`, {method: "PUT", data: payload}, res => setItems(res))
    }
    setChanged(false)
  }
  
  return (
    <>
      <div>
        { FZ && (
            <div >
              <Prompt when={changed} message="Istnieją niezapisane zmiany, czy na pewno chcesz kontynuować?"/>
              <Link to='/fzs'>
                    <label to='back' className="btn btn-link ml-1 text-decoration-none mb-3">
                        <img id='back' src={link}></img>
                    </label>
                </Link>
              <div className='card mb-3'>
                <div className='card-header'>
                  <div className='h5'>
                    {isNew ? "Nowa" : initialFZ.WarehouseOperationFullName || ""}
                  </div>
                  <table className="table table-striped">
                    <tbody>
                    <tr className='justify-content-center'>
                      <td>Nr oryginalny</td>
                      <td>Data faktury</td>
                      <td>Kontrahent</td>
                      <td>Magazyn</td>
                    </tr>
                    <tr>

                      <td>
                        <input
                        disabled={closed}
                        className= {`mt-2 ${!FZ.OriginalDocNumber && `invalid-input`} form-control form-control-sm`}
                        value={FZ.OriginalDocNumber}
                        onChange={evt => {const value = evt.target.value ;setFz(prev => ({...prev, OriginalDocNumber: value || ""}))}}
                        onFocus={() => {setFz(prev => ({...prev, OriginalDocNumber: ""})); setChanged(true)}}
                        />
                      </td>

                      <td>
                        <input
                        disabled={closed}
                        className={`mt-2 form-control form-control-sm ${!FZ.IssuedOn && `invalid-input`}`}
                        type='date'
                        value={FZ.IssuedOn}
                        onChange={evt => {setChanged(true); const value = evt.target.value ;setFz(prev => ({...prev, IssuedOn: value || ""}))}}
                        />
                      </td>
                      <td>
                        <input
                        disabled={closed}
                        value={FZ.ContractorName}
                        placeholder='Wybierz...'
                        className={`mt-2 form-control ${!FZ.ContractorName && `invalid-input`} form-control-sm`}
                        min={1}
                        onFocus={() => {setChanged(true); setFz(prev => ({...prev, ContractorName: "", ContractorId: null}))}}
                        onChange={handleChangeContractor}
                        list='contractors'
                        />
                        <datalist id='contractors'>
                          {
                            contractors && contractors.map((contractor, idx) => (
                              <option value={contractor.Name} key={idx}/>
                            ) )
                          }
                        </datalist>
                      </td>
                      
                      
                      <td>
                        <input
                        disabled={closed}
                        value={FZ.WarehouseFullName}
                        datalist='warehouses'
                        placeholder='Wybierz...'
                        className=  {`mt-2 form-control ${!FZ.WarehouseFullName && `invalid-input`} form-control-sm`}
                        min={1}
                        list='warehouses'
                        onFocus={() => {setChanged(true); setFz(prev => ({...prev, WarehouseFullName: "", FromWarehouseId: null}))}}
                        onChange={handleChangeWarehouse}
                        />
                        <datalist id='warehouses'>
                          {warehouses && warehouses.map((warehouse, idx) => (
                            <option value={warehouse.Name} key={idx}/>
                          ))}
                        </datalist>
                      </td>
                    </tr>
                    <tr className='justify-content-center'>
                      <td>Zapłacona</td>
                      <td>Data płatności</td>
                      <td>Komentarz / dodatkowe informacje</td>
                      <td>Powiązane dokumenty magazynowe</td>
                    </tr>
                    <tr className='justify-content-center'>

                    <td >
                      <div className='d-flex justify-content-center align-items-center'>

                        <input
                          disabled={closed}
                          type='checkbox'
                          className='form-check-input'
                          style={{width: "30px", height: "30px"}}
                          checked={FZ.IsPaid}
                          onChange={() => {setChanged(true); setFz({...FZ, IsPaid: !FZ.IsPaid})}}
                        />
                      </div>
                    </td>
                    <td>
                    <input
                        disabled={closed}
                        type='date'
                        className={`mt-2 ${!FZ.PaymentDate && `invalid-input`} form-control form-control-sm`}
                        value={FZ.PaymentDate}
                        onChange={evt => {setChanged(true); const value = evt.target.value ;setFz(prev => ({...prev, PaymentDate: value || ""}))}}
                        />
                    </td>
                    <td>
                      <input
                        className='mt-2 form-control form-control-sm'
                        type='text'
                        value={FZ.Comment}
                        onChange={evt => {setChanged(true);const value = evt.target.value ;setFz(prev => ({...prev, Comment: value || ""}))}}
                        onFocus={() => {setChanged(true); setFz(prev => ({...prev, Comment: ""}))}}
                      />
                    </td>
                    <td>
                        {FZ.ToWarehouseOperationId &&  <div className="text-nowrap"><Link to={`/pz/${FZ.ToWarehouseOperationId}`} className="btn text-nowrap btn-sm btn-outline-secondary">{FZ.RelatedDoc}</Link></div>}
                    </td>
                    </tr>
                    <tr className='justify-content-center'>
                      <td>Wartość netto</td>
                      <td>Wartość VAT</td>
                      <td>Wartość brutto</td>
                      <td>Stworzona</td>
                    </tr>
                    <tr className='justify-content-center'>
                      <td>{Intl.NumberFormat('pl-PL', {style: "currency", currency: "PLN"}).format(totalNettoSum().toFixed(2)) || "0,00zł"}</td>
                      <td>{Intl.NumberFormat('pl-PL', {style: "currency", currency: "PLN"}).format(totalVatSum().toFixed(2)) || "0,00zł"}</td>
                      <td>{Intl.NumberFormat('pl-PL', {style: "currency", currency: "PLN"}).format(totalBruttoSum().toFixed(2)) || "0,00zł"}</td>
                      <td>{FZ.Created && `${moment(FZ.Created).format("YYYY.MM.DD")} ${FZ.Created.split(" ").at(-1)}`}</td>
                    </tr>
                    {closed && (
                        <tr>
                          <td colSpan={4} className='text-center'>

                          Inwentaryzacja
                          </td>
                        </tr>
                    )}
                    {closed && (
                        <tr>
                          <td colSpan={4}>
                            <div className='text-center mt-1'>
                                <Link
                                to={`/in/${FZ.WarehouseInventoryId}`}
                                    className="btn btn-outline-success"
                                >
                                    {FZ.WarehouseInventory}
                                </Link>
                            </div>
                          </td>
                        </tr>
                    )}
                    </tbody>
                  </table>
                </div>
              </div>
              {!closed && (
                  <div>
                  <button
                    className="d-block btn btn-link text-decoration-none ml-auto mr-1"
                    onClick={() => {setChanged(true); setItems(prev => [{...newFZItem, Name: ""}, ...prev]);}}
                >
                    <i className="fas fa-plus mr-2" />
                </button>
                  </div>
              ) }
              <div className='card' style={{marginBottom: "40px"}}>
                
                <table className="table table-striped ">
                  <thead>
                    <tr>
                      <th style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("Name")}>Produkt{arrow("Name")}</th>
                      <th style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("Quantity")}>Ilość{arrow("Quantity")}</th>
                      <th style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("Price")}>Cena jedn. netto{arrow("Price")}</th>
                      <th style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("PriceNetto")}>Wartość netto{arrow("PriceNetto")}</th>
                      <th style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("VAT")}>Wartość VAT{arrow("VAT")}</th>
                      <th style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("Value")}>Stawka VAT{arrow("Value")}</th>
                      <th style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("PriceBrutto")}>Wartość brutto{arrow("PriceBrutto")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items && items.map((item, idx) => 
                      !item.deleted && 
                      (
                        <tr key={idx}>
                          <td>
                            <input
                              disabled={closed}
                              className={`form-control ${!item.Name && `invalid-input` } form-control-sm mx-auto mx-lg-0`}
                              value={item.Name}
                              onChange={evt => {setChanged(true); handleChangeItem(item.WarehouseOperationItemId, evt)}}
                              list='products'
                              onFocus={() => {setChanged(true); setItems(prev => prev.map(pr => pr.WarehouseOperationItemId === item.WarehouseOperationItemId ? ({...pr, Name: "", ProductId: ""}) : pr))}}
                            />
                            <datalist id='products'>
                              {products && products.map((product, idx) => (<option key={idx} value={product.Name} />))}
                            </datalist>
                          </td>
                          <td>
                            <input
                            disabled={closed}
                            type='text'
                            className={`form-control ${(!item.Quantity || item.Quantity == "0") && `invalid-input` } form-control-sm mx-auto mx-lg-0`}
                            value={item.Quantity}
                            onChange={evt => {setChanged(true); handleChangeQuantity(item.WarehouseOperationItemId, evt.target.value)}}
                            onFocus={() => {setChanged(true); setItems(prev => prev.map(pr => pr.WarehouseOperationItemId === item.WarehouseOperationItemId ? ({...pr, Quantity: ""}) : pr))}}
                            />
                          </td>
                          <td>
                            <input
                            disabled={closed}
                            type='number'
                            className={`form-control ${(!item.Price || item.Price == "0") && `invalid-input` } form-control-sm mx-auto mx-lg-0`}
                            value={item.Price}
                            onChange={evt => {setChanged(true); handleChangePrice(item.WarehouseOperationItemId, evt.target.value)}}
                            onFocus={() => {setChanged(true); setItems(prev => prev.map(pr => pr.WarehouseOperationItemId === item.WarehouseOperationItemId ? ({...pr, Price: ""}) : pr))}}
                            />
                          </td>
                          <td>{Intl.NumberFormat('pl-PL', {style: "currency", currency: "PLN"}).format(getNetto(item)) || "0,00zł"}</td>
                          <td>{Intl.NumberFormat('pl-PL', {style: "currency", currency: "PLN"}).format(getVat(getNetto(item), item.Value)) || "0,00zł"}</td>
                          <td>{item.Value}%</td>
                          <td>{Intl.NumberFormat('pl-PL', {style: "currency", currency: "PLN"}).format(getBrutto(getNetto(item), getVat(getNetto(item), item.Value))) || "0,00zł"}</td>
                          <td>
                            {!closed && (
                              <button className="btn btn-link btn-sm" onClick={() => {setChanged(true); deleteItem(item.WarehouseOperationItemId)}}>
                                <i className="fas fa-trash" />                                
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    
                  </tbody>
                </table>
              </div>
            </div>
          )
          

        
        }
                <div className='position-fixed container' style={{bottom: "0px"}}>

                  <div className="card-footer text-center fixed-bottom" style={{backgroundColor:"#cbcbcb"}}>
                  <button disabled={!avaiableToSave || !changed || isSaved} className={`btn btn-primary w-20  btn-sm`} onClick={handleSubmit}>
                      Zapisz
                  </button>
                  </div>
                </div>
      </div>
    </>
  )
}

export default FZ